import { LayoutService } from 'src/app/layout/layout.service';
import { Component, OnInit } from '@angular/core';
import { MiscellaneousService } from 'src/app/apps/authentication/miscellaneous.service';
import * as g from 'src/app/globals';

@Component({
  selector: 'app-languages-list',
  templateUrl: './languages-list.component.html',
  styleUrls: ['./languages-list.component.less'],
})
export class LanguagesListComponent implements OnInit {
  currentLanguage: string;
  languages: [{ code: string; label: string; flag: string }];

  constructor(
    private miscellaneousService: MiscellaneousService,
    private layoutService: LayoutService
  ) { }

  ngOnInit(): void {
    this.miscellaneousService
      .getLanguages()
      .subscribe((d: [{ code: string; label: string; flag: string }]) => {
        this.languages = d;
        const currentLanguageCode = localStorage.getItem('language');
        this.languages.forEach((lang) => {
          if (lang.code === currentLanguageCode) {
            this.currentLanguage = lang.label;
          }
        });
      });
  }

  changeLanguage(language: { code: string; label: string; flag: string }) {
    localStorage.setItem('language', language.code);
    g.setLanguage(language.code);
    // const sessionId = g.getSessionId();
    const token = g.getToken();
    if (token == null) {
      this.layoutService.setLanguageLogin(language.code).subscribe();
    }
    else {
      this.layoutService.setLanguage(language.code).subscribe();
    }
    window.location.reload();
  }
}
